import { getMainWindowComposeViewState } from 'owa-mail-compose-actions/lib/selectors/getMainWindowComposeViewState';
import type { ComposeViewState } from 'owa-mail-compose-store/lib/store/schema/ComposeViewState';
import { isFeatureEnabled } from 'owa-feature-flags';
import getConversationReadingPaneViewState from './getConversationReadingPaneViewState';
import findInlineComposeViewState from 'owa-mail-compose-actions/lib/utils/findInlineComposeViewState';

/**
 * Get compose state from the active tab
 * Inline compose will be considered based on cmp-ribbon-inlineCompose flag state
 * @returns compose view state from the current active tab
 */
export function getComposeViewState(): ComposeViewState | undefined {
    let composeState = getMainWindowComposeViewState();

    if (!composeState && isFeatureEnabled('cmp-ribbon-inlineCompose')) {
        composeState = getInlineComposeViewState();
    }

    return composeState;
}

/**
 * Get inline compose state from active tab
 * @returns {ComposeState} compose state
 */
export function getInlineComposeViewState(): ComposeViewState | undefined {
    const readingPanelState = getConversationReadingPaneViewState();
    const inlineComposeViewState: ComposeViewState | undefined = findInlineComposeViewState(
        readingPanelState?.conversationId?.Id
    );
    return inlineComposeViewState;
}
